import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../../SectionHeading';

const stats = [
  { label: 'Populația maximă a Pământului (2058)', value: '7,4 Miliarde' },
  { label: 'Populația Pământului în 2501', value: '3 Miliarde' },
  { label: 'Vieți pierdute în colaps și pandemie', value: '4,4 Miliarde' },
  { label: 'Victime Marburg-X (2067–2070)', value: '340 Milioane' },
];

const WorldCostRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Prețul Care Nu a Fost Niciodată Ascuns" subtitle="Bilanțul" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            Aceeași cronică care descrie Venusul terraformat și Titanul colonizat nu se ferește de bilanț. Între populația maximă a Pământului de <span className="text-white font-semibold">7,4 miliarde în 2058</span> și populația sa din 2501 de <span className="text-white font-semibold">3 miliarde</span>, 4,4 miliarde de vieți au fost pierdute — în colapsul climatic, în pandemia Marburg-X, în Marea Eroziune.
          </p>
          <p className="text-gray-400 leading-relaxed">
            Cartea îi numește: profesori din Kinshasa, fermieri mergând spre Mumbai inundată, ingineri de apă murind de deshidratare în timp ce îi salvau pe alții. Nu sunt statistici. Sunt prețul unei civilizații care a știut și a ales să nu acționeze la timp.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="bg-brand-surface border border-white/5 rounded-2xl p-8"
        >
          <div className="space-y-6">
            {stats.map((stat, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 pb-5 last:border-0 last:pb-0">
                <span className="text-gray-500 text-sm pr-4">{stat.label}</span>
                <span className="text-brand-accent font-display font-bold text-xl flex-shrink-0">{stat.value}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default WorldCostRo;